import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Button } from "antd";
import { InfoWindow } from '../../components/googleMap';
import './MapInfoWindow.css';
import MarketplacePostedVehicleHirePanel from "../marketplace/MarketplacePostedVehicleHirePanel";
const MarketplaceVehicleHireInfoWindow = ({ vehicleHire, position, marker, visible, onClose, onAllocateClicked }) => {
    return (_jsx(InfoWindow, { visible: visible, position: position, marker: marker, onClose: onClose, children: vehicleHire &&
            _jsxs("div", { className: "marketplace-info-window", children: [_jsx(MarketplacePostedVehicleHirePanel, { vehicleHire: vehicleHire }), _jsx(Button, { htmlType: "button", onClick: onAllocateClicked, children: "Allocate" }, "assign")] }) }, "MarketplaceVehicleHireInfoWindow"));
};
export default MarketplaceVehicleHireInfoWindow;
